module.exports = __webpack_public_path__ + "img/Group 937.b9963d6d.png";